import Client from "../client";

export class Notification {
  static async list(currentPage: number) {
    return await Client.get<any[]>(`/notification`, { currentPage });
  }

  static async read(objectId: string) {
    return await Client.post<any>(`/notification/${objectId}/read`);
  }
}
